// @flow
import React from 'react'
import styled from 'styled-components'

type Props = {
  placeholder: string,
  values: string[],
  value: string,
  onChange: (val:string) => void
}

type State = {
  open: boolean
}

export default class Dropdown extends React.Component<Props,State> {

    state = {open: false}

    onChange = (value:*) => () => {
      this.setState({open: false})
      this.props.onChange(value)
    }

    toggle = () => this.setState({open: !this.state.open})

    render(){
      const {placeholder, values, value} = this.props
      const {open} = this.state
      const label = value || placeholder
      return (
        <Wrapper className="Dropdown">
          <Label onClick={this.toggle}>
            <span>{label}</span><Icon className="fa fa-caret-down"/>
          </Label>
          {open && <ValueList>
            {values.map(val => <Value key={val} onClick={this.onChange(val)}>{val}</Value>)}
          </ValueList>}
        </Wrapper>
      )
    }
}

const Wrapper = styled.div`
    position: relative;
    cursor: pointer;
`

const Label = styled.div`
    padding: 10px;
    border: 1px solid grey;
    background: whitesmoke;
    display: flex;
    justify-content: space-between;
`

const ValueList = styled.div`
    position: absolute;
    left:0;
    right:0;
    border: 1px solid grey;
    z-index: 100;
    background: white;
`

const Value = styled.div`
    padding: 10px;
    &:hover {background: lightgrey;}
`

const Icon = styled.i`
  font-size: 20px;
  margin: 0 10px;
  color: black;
`


// WEBPACK FOOTER //
// ./src/components/Dropdown.js